import {
  Button,
  Colors,
  Modal,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'
import { isEducator } from 'services/user'
import { IRole } from 'types/database/users/user'

import './style.scss'

interface IProps {
  onAgree: () => void
  open: boolean
  setOpen: (open: boolean) => void
  onClose?: () => void
  role: IRole
}

interface IState {}

export class DeleteChildModal extends React.Component<IProps, IState> {
  onYes = () => {
    const { setOpen, onAgree } = this.props
    onAgree()
    setOpen(false)
  }

  setActive = (status: boolean) => {
    if (!status) {
      const { onClose, setOpen } = this.props
      setOpen(false)
      if (onClose) {
        onClose()
      }
    }
  }

  render() {
    const { open, role } = this.props
    const educator = isEducator(role)
    return (
      <Modal active={open} setActive={this.setActive}>
        <Typography type="title" size="big">
          WARNING
        </Typography>
        {educator ? (
          <Typography type="text">
            Are you sure you want to <br />
            <b>
              <span style={{ color: Colors.redAccent }}>DISCONNECT</span>
            </b>{' '}
            from this child profile?
          </Typography>
        ) : (
          <Typography type="text">
            Are you sure you want to <br />
            <b>
              <span style={{ color: Colors.redAccent }}>DELETE</span>
            </b>{' '}
            this child profile?
          </Typography>
        )}
        <Button color="pink" onClick={this.onYes}>
          {educator ? 'Disconnect Child Profile' : 'Delete Child'}
        </Button>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeleteChildModal/index.tsx